import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f7851f5"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "infodisplay"
};
const _hoisted_2 = {
  key: 0,
  class: "icon iconfont"
};
const _hoisted_3 = {
  key: 1,
  class: "icon iconfont"
};
import { ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'desensitization',
  props: {
    val: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    isShowEye: {
      type: String,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    let isShow = ref(false);
    function desensitization(val, type) {
      let result = "";
      if (val) {
        switch (type) {
          case "phone":
            result = val.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
            break;
          case "idCard":
            result = val.replace(/^(\d{4})\d{10}(\w{4})$/, "$1**********$2");
            break;
          case 'bankCard':
            if (val.length < 10) {
              result = val; // 长度小于10的银行卡号不进行脱敏
            } else {
              const visibleDigits = 6;
              const maskedDigits = val.length - visibleDigits - 4;
              const maskedPart = '*'.repeat(maskedDigits);
              result = val.substring(0, visibleDigits) + maskedPart + val.slice(-4);
            }
            break;
          case 'name':
            if (val.length === 2) {
              const maskedName = '*'.repeat(1);
              result = val[0] + maskedName;
            } else if (val.length >= 3) {
              const maskedName = '*'.repeat(val.length - 2);
              result = val[0] + maskedName + val[val.length - 1];
            } else {
              result = val;
            }
            break;
          case 'full':
            const maskedValue = '*'.repeat(val.length);
            result = maskedValue;
            break;
          default:
            result = val;
            break;
        }
      }
      return result;
    }
    function handleShowInfo() {
      isShow.value = !isShow.value;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, _toDisplayString(_unref(isShow) ? __props.val : desensitization(__props.val, __props.type)), 1), props.isShowEye ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: {
          "margin-left": "10px",
          "cursor": "pointer"
        },
        onClick: handleShowInfo
      }, [!_unref(isShow) ? (_openBlock(), _createElementBlock("span", _hoisted_2, "")) : (_openBlock(), _createElementBlock("span", _hoisted_3, ""))])) : _createCommentVNode("", true)])]);
    };
  }
});